"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCampaignConfig = void 0;
const react_1 = require("react");
const utils_1 = require("../utils");
const brand_provider_1 = require("../../providers/brand.provider");
const useFeatureFlag_1 = require("../../hooks/useFeatureFlag");
const getCyclePeriodDate_1 = require("../../utils/helpers/cycle/getCyclePeriodDate");
const useCampaignConfig = ({ key, catalogSlug }) => {
    const [bannerConfig, isLoading] = (0, useFeatureFlag_1.useFeatureFlag)(key, null);
    const [parsedBannerConfig, setBannerConfigParsed] = (0, react_1.useState)(null);
    const [url, setUrl] = (0, react_1.useState)(null);
    const [isCampaignActive, setIsCampaignPeriod] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (isLoading || !bannerConfig) {
            return;
        }
        const parsedConfig = (0, utils_1.parseAndGetKeyValueConfig)(bannerConfig, {
            key: brand_provider_1.BrandProvider.getBrand(),
            schema: utils_1.campaignBannerConfigSchema,
        });
        if (!parsedConfig) {
            return;
        }
        setBannerConfigParsed(parsedConfig);
        const generatedUrl = (0, utils_1.buildBannerLink)(parsedConfig, catalogSlug);
        setUrl(generatedUrl);
        const campaignPeriod = (0, getCyclePeriodDate_1.getCyclePeriodDate)(parsedConfig.startDate.toISOString(), parsedConfig.endDate.toISOString());
        setIsCampaignPeriod(campaignPeriod);
    }, [bannerConfig, catalogSlug]);
    return {
        bannerConfig: parsedBannerConfig,
        isLoading,
        url,
        isCampaignActive,
    };
};
exports.useCampaignConfig = useCampaignConfig;
